import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

/**
 * Hook to track scroll depth on pages
 * Call this hook in pages that need scroll tracking (Landing, Features, Trade)
 */
export const useScrollTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname;
    
    // Only track scroll on specific pages
    const trackablePages = ['/landing', '/features', '/trade', '/'];
    if (!trackablePages.includes(pagePath)) {
      return;
    }

    let ticking = false;
    let lastScrollPercent = -1;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = scrollHeight > 0 ? Math.round((scrollTop / scrollHeight) * 100) : 0;
          
          // Only track if scroll percent changed significantly (to avoid too many events)
          if (Math.abs(scrollPercent - lastScrollPercent) >= 25) {
            analyticsService.trackScrollDepth(pagePath, scrollPercent);
            lastScrollPercent = scrollPercent;
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    // Throttle scroll events
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);
};

export default useScrollTracking;
